import { render } from "./SurveyVeryBad.vue?vue&type=template&id=f1f8bf3c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__